module.exports = __webpack_public_path__ + "img/notification.785a34db.png";